<template>
  <div>
    <Frontendlayout>
      <section class="hero_in tours">
        <div class="wrapper">
          <div class="container">
            <h1 class="fadeInUp"><span></span>Services We Offer</h1>
          </div>
        </div>
      </section>
      <!--/hero_in-->

      <div class="container-fulid margin_60_35">
        <div class="row">
          <Sidebar />
          <!-- /aside -->

          <div class="col-lg-10">
            <div class="isotope-wrapper">
              <div class="row">
                <div class="box_general padding_bottom">
                  <form
                    autocomplete="off"
                    @submit.prevent="createVendorservices()"
                    method="post"
                  >
                    <div
                      class="form-group"
                      v-for="cat in categories"
                      :key="cat.id"
                    >
                      <h5>
                        <input
                          type="checkbox"
                          :id="'parent_check_' + cat.id"
                          @click="checkChild(cat.id)"
                          v-model="parentCheck"
                        /><label
                          class="form-check-label parentCat"
                          :for="'parent_check_' + cat.id"
                          >{{ cat.category }}</label
                        >
                      </h5>

                      <div
                        v-for="ch in cat.child"
                        :key="ch.id"
                        class="form-check food"
                      >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          :value="ch.id"
                          v-model="category_id"
                          @click="uncheckParent(ch.id, cat.id)"
                          :id="'check_' + ch.id"
                          :class="'childcat parent_check_' + cat.id"
                          :true-value="ch.id"
                          false-value=""
                          @change="update($event)"
                        />
                        <label
                          class="form-check-label"
                          :for="'check_' + ch.id"
                          >{{ ch.category }}</label
                        >
                      </div>
                    </div>

                    <div id="pass-info" class="clearfix"></div>
                    <div class="form-group" :disabled="loading">
                      <span
                        v-show="loading"
                        class="spinner-border spinner-border-sm"
                      ></span>
                    <center>
                      <button
                        type="submit"
                        class="btn_1 rounded add_top_30"
                      >
                        Submit
                      </button>
                    </center>
                    </div>
                  </form>
                </div>
              </div>
              <!-- /row -->
            </div>
            <!-- /isotope-wrapper -->
          </div>
          <!-- /col -->
        </div>
      </div>

      <!-- /container -->
      <!-- /bg_color_1 -->
    </Frontendlayout>
  </div>
</template>

<script>
import API from "@/services/index.js";
import Frontendlayout from "@/layouts/Frontendlayout.vue";
import Sidebar from "@/layouts/Sidebar.vue";
import $ from "jquery";
export default {
  data() {
    return {
      loading: false,
      categories: [],
      category_id: [],
      msg: null,
      classAlert: null,
    };
  },
  components: {
    Frontendlayout,
    Sidebar,
  },
  beforeMount() {
    this.getParentservices();
    this.getservices();
    this.checkToken();
  },
  computed: {
    parentCheck: {
      get: function () {
        return this.categories
          ? this.category_id.length == this.categories.length
          : false;
      },
      set: function (value) {
        //alert("hii");
        var selected = [];

        if (value) {
          this.categories.forEach(function (cat) {
            cat.child.forEach(function (child) {
              if ($("#check_" + child.id).is(":checked")) {
                //alert("#check_" + child.id);
                selected.push(child.id);
              }
            });
            if ($("#parent_check_" + cat.id).is(":checked")) {
              //alert(cat.id + " checked");
            } else {
              //alert(cat.id + " unchecked");
              $("#parent_check_" + cat.id).prop("checked", false);
            }
          });
        }

        this.category_id = selected;
      },
    },
  },
  methods: {
    checkToken() {
      const token = localStorage.getItem("token");
      // alert(token);
      if (token == null) {
        this.$router.push("/signin");
      }
    },

    checkChild(parentId) {
      $(".parent_check_" + parentId).prop("checked", false);
      if ($("#parent_check_" + parentId).is(":checked") == true) {
        $(".parent_check_" + parentId).prop("checked", true);
      }
    },
    uncheckParent(id, parentId) {
      //alert($(".parent_check_" + parentId).length);
      if ($("#check_" + id).is(":checked") == true) {
        if (
          $(".parent_check_" + parentId).length ==
          $("input:checkbox.parent_check_" + parentId + ":checked").length
        ) {
          $("#parent_check_" + parentId).prop("checked", true);
        }
      } else {
        $("#parent_check_" + parentId).prop("checked", false);
      }
    },
    getservices() {
      const token = "Bearer " + localStorage.getItem("token");
      // alert(token);

      API.get("profile/get_services", {
        headers: { Authorization: token },
      })
        .then((res) => {
          this.areaofinterest = res.data.data;
          res.data.data.forEach((value) => {
            this.category_id.push(value.category_id);
          });
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    getParentservices() {
      const token = "Bearer " + localStorage.getItem("token");
      // alert(token);

      API.get("categories/parent_services", {
        headers: { Authorization: token },
      })
        .then((res) => {
          this.categories = res.data.data;
          console.log(this.categories);
        })
        .catch((err) => {
          console.log(err.response);
        });
    },

    createVendorservices() {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "bottom-right",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      this.loading = true;
      if (this.category_id == "") {
        this.msg = "please select atleast 1 category";
        this.loading = false;
        return false;
      }
      const form = new FormData();
      form.append("category_id", this.category_id);
      const token = "Bearer " + localStorage.getItem("token");
      API.post("/vendor/add_services", form, {
        headers: { Authorization: token },
      }).then((res) => {
        this.loading = false;
        console.log(res.data);
        if (res.data.status == 200) {
          this.category_id = "";
          Toast.fire({
            icon: "success",
            title: res.data.messages,
          });
          this.$router.push("/packages");
        } else {
          Toast.fire({
            icon: "error",
            title: res.data.messages,
          });
        }
      });
      //axios
    },
  },
};
</script>

<style  scoped>
.form-group {
  width: 100%;
  position: relative;
  margin: 10px 8px;
  float: left;
}
.form-check.food {
  width: 48%;
  margin: 0 8px;
  float: left;
}
.form-check.merchandise {
  width: 30%;
  margin: 0 8px;
  float: left;
}
.form-check.services {
  width: 30%;
  margin: 0 8px;
  float: left;
}
.form-check-input {
  margin: 5px 0;
}
.form-check-label {
  margin-left: 20px;
  margin-top: 0;
}
figure h2 {
  position: relative;
  top: 30px;
}
a.btn_1.full-width,
.btn_1.full-width {
  width: unset !important;
  display: unset !important;
  border-radius: 15px !important;
  padding: 8px 20px;
}
.box_general {
  padding: 25px !important;
}
</style>